import React from 'react';
import { connect } from 'react-redux';
import { toastr } from 'react-redux-toastr';
import { Button, Icon } from 'semantic-ui-react';
import { addAttachments, removeFile, removeAttachments } from './actions';

class UploadFiles extends React.Component {
  constructor(props) {
    super(props);

    this.handleClick = this.handleClick.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handleRemoveFile = this.handleRemoveFile.bind(this);
  }

  componentDidMount() {
    this.props.removeAttachments();
  }

  handleClick() {
    const { upload } = this.refs;
    upload.click();
  }

  handleRemoveFile(fileName) {
    const { upload } = this.refs;
    upload.value = '';
    this.props.removeFile(fileName);
  }

  handleChange(event) {
    const { files } = event.target;
    const { length } = files;

    const uploaded = [];

    for (let i = 0; i < length; i += 1) {
      uploaded.push(files[i]);
    }

    return this.props.addAttachments(uploaded);
  }

  render() {
    const { attachments } = this.props.uploadCashback;

    const renderUploadFiles =
      attachments &&
      attachments.map(el => (
        <div key={el.name}>
          <Icon name="attach" /> <span style={{ color: '#0d7daf', fontSize: '1.2em' }}>{el.name}</span>{' '}
          <span
            style={{
              color: '#db2828',
              fontSize: '.9em',
              paddingLeft: '1em',
              cursor: 'pointer',
            }}
            onClick={() => this.handleRemoveFile(el.name)}
          >
            {' '}
            Remove{' '}
          </span>
        </div>
      ));

    return (
      <div style={{ marginTop: '2em' }}>
        <input
          style={{
            cursor: 'pointer',
            visibility: 'hidden',
            width: '0.1px',
            height: '0.1px',
          }}
          type="file"
          onChange={this.handleChange}
          ref="upload"
          accept=".csv"
        />
        <Button basic color="blue" onClick={this.handleClick}>
          <Icon name="attach" />
          Choose CSV File
        </Button>
        <div style={{ margin: '0 auto', marginTop: '2%' }}>
          {attachments && attachments.length ? renderUploadFiles : ''}
        </div>
      </div>
    );
  }
}

function mapStateToProps({ uploadCashback }) {
  return {
    uploadCashback,
  };
}

export default connect(mapStateToProps, {
  addAttachments,
  removeFile,
  removeAttachments,
})(UploadFiles);



// WEBPACK FOOTER //
// ./src/Modules/UploadCashBackFile/UploadComponent/index.jsx